import "./StrategicCommunication.module.css";
import Header from "@/reusable_sections/Header";
import ProgramOverview from "./sections/ProgramOverview";
import ModuleBreakdown from "./sections/ModuleBreakdown";
import RequestMoreInformation from "./sections/RequestMoreInformation";
import Footer from "@/reusable_sections/Footer";
export default function StrategicCommunicationPage() {
  return <div>
      <Header />
      <ProgramOverview />
      <ModuleBreakdown />
      <RequestMoreInformation />
      <Footer />
    </div>;
}